import React from 'react';
import { CardHeader, Input, Label } from 'reactstrap';

const ForeCastPreviewCardHeader = ({ title, toggleText, handelForecastBudget, handelForecastLastYear }) => {
    return (
        <React.Fragment>
            <CardHeader className="align-items-center d-flex">
                <div className="mb-0 flex-grow-1">{title}</div>
                {/* <div className="flex-shrink-0 me-2">
                    <div className="form-check form-switch form-switch-right form-switch-md">
                        <Label className="form-label text-muted">Budget</Label>
                        <Input className="form-check-input budget-switcher" type="checkbox" onChange={handelForecastBudget} />
                    </div>
                </div> */}
                {/* <div className="flex-shrink-0 me-2">
                    <div className="form-check form-switch form-switch-right form-switch-md">
                        <Label className="form-label text-muted">Last Year</Label>
                        <Input className="form-check-input last-year-switcher" type="checkbox" onChange={handelForecastLastYear}/>
                    </div>
                </div> */}
                <div className="flex-shrink-0">
                    <div className="form-check form-switch form-switch-right form-switch-md">
                        <Label className="form-label text-muted">{toggleText??'Show Code'}</Label>
                        <Input className="form-check-input code-switcher" type="checkbox" />
                    </div>
                </div>
            </CardHeader>
        </React.Fragment>
    );
}

export default ForeCastPreviewCardHeader;